export interface DateRange {
  start: string;
  end: string;
  aggregateBy: AggregateBy;
}

export type AggregateBy = 'day' | 'week' | 'month' | 'quarter';

export enum EntityKinds {
  group = 'Team',
  bu = 'bu',
  ou = 'ou',
}

export interface ProposedOwnershipRepo {
  id: string;
  entity: string;
  entityName: string;
  entitySubtext: string;
  repository: string;
  repositoryName: string;
  teamRecommendation: string;
  teamEntityRef: string;
  entityRef: string;
  repositoryUrl?: string;
  source: 'catalog' | 'watchtower';
  proposedByEmail?: string;
  recommendationType?: string;
}

export interface AcceptOwnershipResult {
  repository_name: string;
  status: 'ACCEPTED';
  repository_updated: boolean;
  recommendation_updated: boolean;
  accepted_by: string;
  accepted_at: string;
}

export interface AcceptOwnershipResponse {
  data: AcceptOwnershipResult[];
  total_requested: number;
  total_accepted: number;
  total_repository_updates: number;
}

export interface AcceptOwnershipRequest {
  repository_name: string;
  owner_team_id: string;
  owner_team_name: string;
  owner_manager: string;
  owner_cost_center: string;
  owner_cost_center_id?: string;
  owner_ou: string;
  owner_bu: string;
  accepted_by: string;
}

export interface MarkOwnershipUnknownRequest {
  repository_name: string;
  marked_unknown_by: string;
}

export interface MarkOwnershipUnknownResult {
  repository_name: string;
  status: 'MARKED_UNKNOWN';
  repository_updated: boolean;
  marked_unknown_by: string;
  marked_unknown_at: string;
}

export interface MarkOwnershipUnknownResponse {
  data: MarkOwnershipUnknownResult[];
  total_requested: number;
  total_marked_unknown: number;
  total_repository_updates: number;
}

export interface UpdateOwnershipItem {
  repository_name: string;
  owner_confirm: boolean;
  owner_team_id?: string;
  owner_team_name?: string;
  owner_manager?: string;
  owner_cost_center?: string;
  owner_cost_center_id?: string;
  owner_ou?: string;
  owner_bu?: string;
  updated_by: string;
}

export interface UpdateOwnershipRequest {
  updates: UpdateOwnershipItem[];
}

export interface UpdateOwnershipResult {
  repository_name: string;
  owner_confirm: boolean;
  repository_updated: boolean;
  updated_by: string;
  updated_at: string;
}

export interface UpdateOwnershipResponse {
  data: UpdateOwnershipResult[];
  total_requested: number;
  total_updated: number;
  failed: Array<{ repository_name: string; error: string }>;
  generated_at: string;
}
